import type { ChangeEvent } from 'react';

import { Progress } from 'src/app/components/Elements';
import { UploadImage } from 'src/app/components/Form/UploadIDField/UploadImageField';
import { ID_UPLOAD_STATUS } from 'src/consts';

import styles from './styles.module.scss';

import type { InsuranceCardState } from '.';

interface InsuranceUploadAndShowProps {
  insuranceCard: InsuranceCardState;
  handleFileUpload: (event: ChangeEvent<HTMLInputElement>, cardType: string) => void;
  bodyText: string;
}

export const InsuranceUploadAndShow = ({ insuranceCard, handleFileUpload, bodyText }: InsuranceUploadAndShowProps) => {
  switch (insuranceCard.status) {
    case ID_UPLOAD_STATUS.loading:
      return (
        <div className={styles.customColor}>
          <Progress color="inherit" />
        </div>
      );
    case ID_UPLOAD_STATUS.empty:
      return (
        <UploadImage
          name={insuranceCard.type}
          handleFileUpload={e => {
            e.persist();
            handleFileUpload(e, insuranceCard.type);
          }}
          bodyText={bodyText}
        />
      );
    case ID_UPLOAD_STATUS.unverified:
      return (
        <div className={styles.customAccount}>
          <img className={styles.cardImg} src={insuranceCard.url} />
        </div>
      );
    default:
      return null;
  }
};
